// Phase SE-1 — Slip Extractor page (tier guard).
// Phase SE-2 — Mounts SlipExtractorPageV2 (the full shell) for
// Starter+ users.
//
// Per Every Document/Gaps/SlipExtractor_Build_Plan_v1.0.md §6.6:
// Starter+ users (sika_pro and above) see the v2 page; Free users
// see a PaywallCard routing them to upgrade.

import { PaywallCard } from "../../components/PaywallCard.tsx";
import { useUserTier } from "../../auth/useUserTier.ts";
import { SlipExtractorPageV2 } from "./SlipExtractorPage.v2.tsx";

export function SlipExtractorPage(): JSX.Element {
  const { hasTier, loading } = useUserTier();

  if (loading) {
    return (
      <div
        className="sa-root"
        data-testid="slip-extractor-loading"
        style={{ padding: 24 }}
      >
        <div
          className="mono"
          style={{
            fontSize: 11,
            letterSpacing: "0.18em",
            color: "var(--sa-fg-muted, #666)",
            textTransform: "uppercase",
          }}
        >
          Loading…
        </div>
      </div>
    );
  }

  // Starter+ gate (locked v1.1). sika_pro is the lowest paid tier in
  // the current hierarchy and matches "Starter+" semantics.
  if (!hasTier("sika_pro")) {
    return (
      <div
        className="sa-root"
        data-testid="slip-extractor-paywall"
        style={{ padding: 24 }}
      >
        <PaywallCard
          requiredTier="sika_pro"
          featureName="Slip Extractor"
          pitch="Upload an unbet slip and tell STRIKZA what to do with it — filter risky legs, build a target-odds subset, or distil the highest-EV combination. Available on Starter and above."
        />
      </div>
    );
  }

  // SE-2 — Starter+ users land on the full v2 shell.
  return <SlipExtractorPageV2 />;
}
